import Permissions from "../../models/Permissions";

const Main = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: false,
  showInMenu: true,
  label: "Dashboard",
  icon: "fa fa-dashboard",
  permissions,
};

export default [
  {
    path: "/",
    name: "Main",
    component: Main,
    meta,
  },
];
